<template>
  <div class="mainmenu-container primary-bg">
    <div class="logo-container">
        <div class="content-container">
          <div class="top-divider"/>
          <span class="content-text"> #WEIDEN <span class="yellow-text"> 2040 </span> </span>
          <div class="bottom-divider"/>
          <div class="subtitle"> Zukunft! Du willst sie? Dann wähl sie!</div>
        </div>
    </div>

    <div class="tiles">
      <div class="tile tertiary-bg" @click="$router.push('/vision')">
        <div class="vote-container">
          <div class="vote">
              Unsere Vision
          </div>
        </div>
        <div class="tile-text">
          Was wir in unserer Stadt sehen wollen.
        </div>
      </div>
      <div class="tile tertiary-bg" @click="$router.push('/programm')">
        <div class="vote-container">
          <div class="vote">
            Das Programm
          </div>
        </div>
        <div class="tile-text">
          Wie wir dorthin kommen wollen.
        </div>
      </div>
      <div class="tile tertiary-bg" @click="$router.push('/kandidaten')">
        <div class="vote-container">
          <div class="vote">
            Kandidaten
          </div>
        </div>
        <div class="tile-text">
          Wer uns dorthin bringen soll.
        </div>
      </div>
      <div class="tile tertiary-bg" @click="$router.push('/poll')">
        <div class="vote-container">
          <div class="vote">
            gestalte mit
          </div>
        </div>
        <div class="tile-text">
          Lass uns Deine Ideen für Weiden wissen!.
        </div>
      </div>
    </div>

    <div class="feedback">
      <div>
        Und Deine Vision?
      </div>
      <div>
        Ich will, dass Weiden...
      </div>
      <input class="feedbackInput"/>
    </div>


  </div>
</template>

<script>
export default {
  name: 'MainMenu',
  data() {
    return {
      key: "value"
    }
  },
  methods: {
    name() {

    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.mainmenu-container {
  padding: 20px;
  height: 100%;
  padding-top: 10px;
  text-align: left;
}

.tiles {
  padding-top: 30px;
  padding-bottom: 30px;
  padding-right: 20px;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: 50% 50%;
  grid-gap: 20px;
}


.logo-container {
  min-width: 150px;
  height: 60px;
  line-height: 40px;
  text-align: center;
  padding: 20px 40px;
  transition: all 0.1s;
  cursor: pointer;
  font-size: 40px;
  color: white;
  margin-bottom: 40px;
}

.subtitle {
  font-size: 0.3em;
  text-align: left;
  margin-top: -10px;
}

.top-divider {
  border-top: 4px solid white;
  margin-bottom: 6px;
}

.top-divider-black {
  border-top: 2px solid $primary;
  margin-bottom: 4px;
}

.bottom-divider-black {
  border-top: 2px solid $primary;
  margin-bottom: 4px;
}


.bottom-divider {
  border-bottom: 4px solid white;
  margin-top: 6px;
}

.content-container{
  display: inline-block;
}

.content-text {
  font-family: 'Arvo Gruen', serif;
  font-size: 1.0em;
}

.feedback {
  padding-top:20px;
  background: $gDarkYellow;
  text-align: center;
  border-radius: $border-radius;
}

.feedbackInput {
  width:  80%;
  height: 80px;
  margin: 30px;
  border-radius: $border-radius;
}

.tile-header{
  font-family: 'Arvo', serif;
  text-align: center;
  font-size: 0.9em;
  color: $primary;
}

.tile-text{
  font-family: 'PT Sans', serif;
  text-align: center;
  font-size: 0.8em;
}
.tile {
  @include shadow;
  font-family: 'Arvo', serif;
  border-radius: $border-radius;
  cursor: pointer;
  padding: 20px;
}
</style>
